export const TIMER_SCALE_ANIMATE = 1000;
